module.exports = {
	"base": {
		"welcome": "%{name}, добро пожаловать в Mulligans!",
		"user": "Сведения о пользователе",
		"devices": "Устройства",
		"refunds": "Возмещенные средства",
		"resources": "Материалы",
		"transactions": "Заказы и возвраты",
		"email": "Электронная почта",
		"password": "Пароль",
		"save": "Сохранить",
		"sign-out": "Выйти",
		"cancel": "Отмена",
		"close": "Закрыть",
		"learn-more": "Подробнее",
		"required": "Обязательно",
		"support": "Поддержка",
		"bookshelf": "Книжная полка",
		"launch": "Запустить",
		"download": "Загрузить",
		"details": "Подробнее",
		"cannot-be-blank": "Поле %{field} не может быть пустым.",
		"saving": "Cохранение...",
		"done": "Готово",
		"failed": "Ошибка",
		"copy": "Копировать"
	},
	"signin": {
		"login-failure": "Неверный адрес эл. почты или пароль",
		"welcome-large": "Добро пожаловать в <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Вход",
		"forgot-password": "Забыли пароль",
		"new-to-vst": "Впервые пользуетесь %{brand}?",
		"create-account": "Создать учетную запись",
		"signing-in": "Вход в систему...",
		"signin-failed": "Не удалось войти в систему"
	},
	"transactions": {
		"price": "Цена",
		"excluded": "(Исключая налоги)",
		"quantity": "Количество",
		"confirmation#": "Подтверждение #",
		"payment": "Оплата",
		"purchased": "Покупки",
		"purchase-details": "Сведения о покупке",
		"subtotal": "Сумма без учета налогов",
		"total": "Итого",
		"tax": "Налог",
		"loading": "Ваши транзакции загружаются, сейчас все прояснится…",
		"no-purchases": "У вас нет покупок.",
		"seller-vat": "НДС с продажи",
		"total-vat": "Всего заплачено: %{vat}",
		"portion": "%{subTax} Налог %{rate}%",
		"vat-disclosure": "Цена с учетом %{vat}",
		"purchases": "Покупки",
		"refunded-items": "Товары, по котором осуществлен возврат средств",
		"book-title": "Наименование книги",
		"refund-details": "Сведения о возврате",
		"print-receipt": "Напечатать квитанцию",
		"request-refund": "Запросить возврат средств",
		"expired": "Срок действия истек",
		"expires-in": "Срок действия истекает %{date}",
		"details-refund": "Подробные сведения и возврат оплаты",
		"modal": {
			"cant-refund-title": "Возврат невозможен",
			"cant-refund": "Средства, уплаченные вами за эту книгу, невозможно возместить по следующим причинам.",
			"cant-refund-1": "Слишком большая часть книги уже просмотрена.",
			"cant-refund-2": "Прошло более 14 дней с момента покупки.",
			"cant-refund-3": "Запрошен и показан код доступа к онлайн-материалам.",
			"cant-refund-4": "Возврат за эту книгу уже выполнялся.",
			"cant-refund-5": "Все коды использованы/средства возвращены.",
			"cant-refund-6": "С момента покупки прошло более 30 дней.",
			"cant-refund-support": "Если у вас остались вопросы по поводу политики возврата средств %{brand}, обратитесь <a href='%{support_url}' target='_blank'>в службу поддержки</a>."
		},
		"license": {
			"perpetual": "Доступ к веб-данным является бессрочным",
			"days": "%{days}-дневный доступ"
		}
	},
	"devices": {
		"description": "%{brand} позволяет одновременно активировать не более <span>%{desktop}</span> компьютеров и <span>%{mobile}</span> смартфонов/планшетов.",
		"loading": "Получение информации о ваших устройствах…",
		"no-active": "У вас нет активных устройств.",
		"deactivate": "Деактивировать"
	},
	"user": {
		"personal-information": "Личные сведения",
		"security-information": "Сведения о безопасности",
		"notifications": "Уведомления",
		"first-name": "Имя",
		"last-name": "Фамилия",
		"change-password-title": "Изменить пароль",
		"current-password": "Текущий пароль",
		"new-password": "Новый пароль",
		"security-password": "Пароль",
		"confirm-new-password": "Подтвердить новый пароль",
		"security-question": "Секретный вопрос",
		"security-info-change": "Изменить",
		"question": "Вопрос",
		"answer": "Ответ",
		"notifications-text": "Прошу отправлять на мой адрес информацию о действиях в моей учетной записи, обновлениях продуктов и специальных предложениях.",
		"loading": "Spot получает ваши данные, подождите немного 🐶",
		"change-password-text": "Пароль должен содержать как минимум 8 символов, среди которых должны быть 1 строчная буква, 1 прописная буква и 1 специальный символ.",
		"email-locked": "Адрес электронной почты заблокирован",
		"email-locked-description": "У вас нет доступа для изменения электронного адреса.",
		"email-locked-more": "Обратитесь к своему администратору.",
		"security-question6": "Какой у вас любимый вид спорта?",
		"security-question7": "Ваше любимое мороженое?",
		"security-question8": "Как зовут вашего домашнего любимца?",
		"security-question9": "Кем вы хотели стать в детстве?",
		"security-question10": "Какая была фамилия у вашего любимого учителя?",
		"new-password-failure": "Пароль не соответствует требованиям",
		"confirm-password-failure": "Пароли должны совпадать",
		"new-password-tooltip": "Должен содержать не менее 8 символов, в том числе заглавную букву, строчную букву и специальный символ.",
		"enter-valid-email": "Введите действующий эл. адрес",
		"password-cannot-be-same": "Новый пароль не может совпадать со старым.",
		"incorrect-password": "Неверный пароль",
		"complete-account": "Кажется, вам нужно завершить <a href='%{href}'>создание учетной записи</a>",
		"completing-allows": "Завершив создание учетной записи, вы сможете читать книги в автономном режиме через мобильные приложения, а также делиться заметками и маркерами с друзьями.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Дополнительные материалы",
		"access-codes": "Коды доступа",
		"print-on-demand": "Печать по запросу",
		"check-pod": "Просмотрите варианты полиграфической печати книг.",
		"check-now": "Проверить",
		"loading": "Подождите немного, ваши материалы обновляются.",
		"in": "в",
		"access-code-intro": "Код доступа — это пароль для доступа к содержимому веб-курса. После того как вы нажали кнопку «Показать код», возврат средств за этот элемент уже невозможен. Чтобы получить дополнительную информацию об использовании кодов доступа, обратитесь в <a href='%{support_url}' target='_blank'>службу поддержки</a>.",
		"expires": "Срок действия истекает",
		"expiration-message": "Содержит инструкции по использованию кода доступа.",
		"copy-fail": "Не удается скопировать. Выделите код и скопируйте его вручную.",
		"launch-site": "Запустить сайт",
		"launch-book": "Запустить книгу",
		"reveal-code": "Показать код",
		"no-resources": "У вас нет материалов.",
		"no-access-codes": "У вас нет кодов доступа.",
		"no-ancillaries": "К этой книге нет дополнительных материалов.",
		"name": "Имя",
		"type": "Тип",
		"size": "Размер",
		"download-all": "Загрузить все",
		"back": "Вернуться к ресурсам"
	},
	"refunds": {
		"states": {
			"refunded": "Средства возмещены",
			"unavailable": "Возврат невозможен"
		},
		"reasons": {
			"dropped": "Я больше не изучаю этот курс.",
			"wrong": "Эта книга не подходит для моего курса.",
			"print": "Я куплю печатную версию вместо электронной.",
			"missing": "В комплекте этой книги отсутствуют некоторые элементы для моего курса (например, компакт-диск, код доступа к веб-материалам, видео).",
			"other": "Другое"
		},
		"bulk": {
			"policy": "Нажав кнопку «Возвратить средства», я подтверждаю согласие с  <a href='%{policy_url}' target='_blank'>условиями %{brand}.</a>",
			"complete": "Возвратить средства",
			"view-details": "Просмотреть сведения о возврате средств",
			"success": "Запрос о возврате оплаты отправлен. Обработка запроса занимает до 48 часов.",
			"failure": "Ой! Что-то пошло не так. К сожалению, возвратить средства не удалось.",
			"retry": "Повторите попытку",
			"support": "Обратиться в службу поддержки",
			"available-codes": "Доступные коды",
			"codes-selected": "Выбранные коды",
			"download": "Загрузить коды",
			"partially-refunded": "Средства частично возвращены",
			"pick-one": "Для возврата средств выберите хотя бы один код"
		},
		"refund": "Возвратить средства",
		"all": "Возвратить все средства?",
		"missing-reason": "Выберите причину, чтобы продолжить",
		"missing-elaboration": "Укажите причину",
		"policy": "Нажимая кнопку «Отправить запрос возврата» внизу, я понимаю, что в случае повторной покупки этого электронного учебника на %{brand} я больше не смогу возместить потраченные на него средства. Показать полный текст политики возврата средств.",
		"refunded": "Средства возмещены",
		"sorry": "Очень жаль, что вы остались недовольны покупкой.",
		"error": "Что-то пошло не так",
		"error-explain": "Невозможно обработать запрос на возврат средств. Повторите попытку позже.",
		"why": "Можете рассказать, почему вы оформляете возврат?",
		"no-refunds": "У вас пока нет возвратов.",
		"select-codes": "Выберите коды для возврата средств:",
		"number": "Сколько?",
		"back": "Вернуться к возмещенным средствам"
	},
	"purchases": {
		"back": "Вернуться к покупкам"
	},
	"global-bar": {
		"account": "Настройки учетной записи"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/ru.json
 ** module id = 1022
 ** module chunks = 0
 **/